import api from './api';

const paymentService = {
  getAll: async () => {
    const response = await api.get('/payments');
    return response.data;
  },
  create: async (data) => {
    const response = await api.post('/payments', data);
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`/payments/${id}`);
    return response.data;
  }
};

export default paymentService;